export default {
  defaultQueue: {
    title: {
      en: 'Time’s ticking...',
    },
    buttonTitle: {
      en: 'Choose your fragrance',
    },
    buttonMakeupTitle: {
      en: 'Choose your makeup',
    },
    note: {
      en: `
        Add products to your queue in the next 12 hours to lock in
        everything you want to try in the coming months!
      `,
    },
  },
  lockedQueue: {
    title: {
      en: 'Explore Scentbird',
    },
    buttonTitle: {
      en: 'Explore Scentbird now',
    },
    note: {
      en: `
        Did you know that Scentbird carries hundreds of makeup, skincare
        and wellness products along with perfumes? Explore them today
      `,
    },
  },
}
